module.exports = __webpack_public_path__ + "abf416fd6d7c05ebb32c59a8ed1b6831.png";